import { takeEvery } from 'redux-saga/effects';

import * as phoneActionTypes from 'store/modules/phone/actionTypes';

import { checkVerificationCode } from './utils';

export default function* listenCheckVerificationCode() {
  yield takeEvery(phoneActionTypes.CHECK_VERIFICATION_CODE, checkVerificationCode);
}
